import { debouncer, documentReady } from "../Utility/utils";

documentReady((event) => {
  // Play videos on play button
  document.addEventListener('click', function(e) {
    if (e.target.matches('a.video_block__trigger') || !!e.target.closest('a.video_block__trigger')) {
      e.preventDefault();

      const target = e.target.closest('.video_block');
      const trigger = target.querySelector('a.video_block__trigger');

      // Fade out trigger
      trigger.classList.add('fadeOut');
      setTimeout(function(){
        trigger.classList.add('hide');
      }, 300);

      // if the video is an iframe
      if(!!target.querySelector('iframe')){
        const iframe = target.querySelector('iframe');
        const src = iframe.getAttribute('src');
        const playSrc = src + '&autoplay=true';
        iframe.setAttribute('src', playSrc);
      } else {
        const video = target.querySelector('video.video__video_media');
        video.play();
      }
    }
  });

  document.querySelectorAll('vimeo-video').forEach(elem =>{
    const iframe = elem.shadowRoot.querySelector('iframe');
    iframe.part.add('vimeo-iframe');

    iframe.setAttribute('allowfullscreen', true);
    iframe.setAttribute('mozallowfullscreen', true);
    iframe.setAttribute('webkitallowfullscreen', true);

  });

  document.querySelectorAll('media-controller').forEach(elem =>{
    elem.addEventListener('mediaenterfullscreenrequest',()=>{
      const vimeo = elem.querySelector('vimeo-video');
      if(vimeo) {
        vimeo.api.requestFullscreen();
      }
    })
  });
});

